import React from "react";
import utils from "utils";

const HeaderTitle = ({ title, patientName, patientLastName, patientAge, patientGender }) => {
  return (
    <div className="header-with-patient-details">
      <div className="header-title">{title}</div>
      <div className="patient-details">
        <div className="patient-first-last-name">{utils.FirstNameLastName(utils.FormatName(utils.getDisplayName(patientName, patientLastName)),"250px")} |</div>
        <div>{patientAge} Years |</div>
        <div>{utils.Capitalize(patientGender)}</div>
      </div>
    </div>
  );
};
export default HeaderTitle;
